<section class="w-full flex flex-wrap rounded-lg px-0 py-4">
  <app-header
    class="border-b border-gray-100 dark:border-gray-600 bg-white dark:bg-gray-900"
    [_Config]="headerConfig"
    (close)="close()"
  ></app-header>

  <main class="w-full flex flex-wrap mt-4 px-4 h-[150px]">
    <p class="w-full text-center text-gray-500 text-base">افزودن قفسۀ جدید</p>

    <input
      class="rounded-lg w-full bg-gray-100 text-gray-500"
      type="text"
      id="shelfTitle"
      tabindex="1"
      [(ngModel)]="createShelf.title"
      placeholder="عنوان قفسه"
    />

    <button
      class="btn-green-flat w-full mt-4"
      [disabled]="!createShelf.title || createShelf.title.trim()?.length < 2"
      (click)="createNewShelf()"
    >
      ایجاد قفسه
    </button>
  </main>
</section>
